const sign = {
  path: 'sign',
  component: resolve => require(['../../../../components/pages/student_user/sign'], resolve)
}
export default sign
